import { createStyles, makeStyles } from '@material-ui/core/styles';
import { theme } from '../Theme';
import { getOpacityColor } from '../utils/constants';

var createSwitchColor = function (color) {
  return {
    '& .Mui-checked': {
      color: color + " !important"
    },
    '& .Mui-checked:hover': {
      backgroundColor: getOpacityColor(color)(0.1) + " !important"
    },
    '& .Mui-checked + .MuiSwitch-track': {
      backgroundColor: color + " !important"
    },
    '& + .MuiFormControlLabel-label': {
      fontSize: '1rem'
    }
  };
};

var useStyles = makeStyles(function () {
  var _theme$colors = theme.colors,
      primaryColor = _theme$colors.primaryColor,
      successColor = _theme$colors.successColor,
      dangerColor = _theme$colors.dangerColor,
      infoColor = _theme$colors.infoColor,
      warningColor = _theme$colors.warningColor;
  return createStyles({
    primary: createSwitchColor(primaryColor),
    info: createSwitchColor(infoColor),
    success: createSwitchColor(successColor),
    warning: createSwitchColor(warningColor),
    danger: createSwitchColor(dangerColor)
  });
});
export default useStyles;